import { Stack } from '@mui/joy';

import { COMPONENT_EMPTY_NAME } from 'bom/constants';
import { IBomPart } from 'bom/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';

interface IProps {
  bomPart: IBomPart;
  extra?: string;
}

export const PartDescriptionTypePart = ({ bomPart, extra }: IProps) => {
  return (
    <Stack>
      <TextLine
        text={
          bomPart?.partArr?.descriptionLong || bomPart?.partArr?.description || DEFAULT_PLACEHOLDER
        }
        maxRows={4}
        textEllipsis
      />

      {1 === bomPart?.partArr?.verified &&
        bomPart?.componentName &&
        COMPONENT_EMPTY_NAME !== bomPart?.componentName && (
          <TextLine text={bomPart?.componentName} italic />
        )}

      {extra && <TextLine text={extra} bold upperCase />}
    </Stack>
  );
};
